export const BlurQueueStatus = Object.freeze({
  BLURRED: "BLURRED",
  NOT_BLURRED: "NOT_BLURRED",
  FAILED: "FAILED",
  REJECTED: "REJECTED",
  IN_REVIEW: "IN_REVIEW",
});
